import { useCallback, useEffect, useState } from "react";
import axios from "axios";

import { API } from "@/lib/api";

/**
 * Listagem genérica de um recurso admin (orçamentos, contatos, newsletter)
 * com atualização de status e remoção — mesmo padrão de useGalleryPhotos,
 * generalizado pra reaproveitar entre os 3 CRUDs novos.
 *
 * @param {string} resource caminho da API, ex.: "/quotes", "/contacts"
 * @param {string} pin PIN do admin (vem do AdminAuthProvider)
 */
export function useAdminList(resource, pin) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refresh = useCallback(async () => {
    if (!pin) return;
    setLoading(true);
    setError(false);
    try {
      const { data } = await axios.get(`${API}${resource}?pin=${encodeURIComponent(pin)}`);
      setItems(data || []);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [resource, pin]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const remove = useCallback(
    async (id) => {
      await axios.delete(`${API}${resource}/${id}?pin=${encodeURIComponent(pin)}`);
      setItems((prev) => prev.filter((item) => item.id !== id));
    },
    [resource, pin]
  );

  const updateStatus = useCallback(
    async (id, status) => {
      await axios.patch(`${API}${resource}/${id}?pin=${encodeURIComponent(pin)}`, { status });
      setItems((prev) => prev.map((item) => (item.id === id ? { ...item, status } : item)));
    },
    [resource, pin]
  );

  return { items, loading, error, refresh, remove, updateStatus };
}
